import { client } from "api";
import { Office } from "models/Office";

export type DeleteOfficeRequest = { id: number };

export type DeleteOfficeResponse = Office[];

export const deleteOffice = ({ id }: DeleteOfficeRequest) =>
  client.delete<DeleteOfficeResponse>(`/office/${id}`).then((res) => res.data);
